module.exports = __webpack_public_path__ + "img/zycp002.852fc8ad.jpg";